<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "BaseFooter",
  
})
</script>
<template>
    <!-- <div> -->
    <div v-if="store.showDown" class="footer-down-wrap">
        <div class="down-close" @click="store.showDownload = false"><img src="@/assets/img/home/down_close.png" /></div>
        <div class="down-content">
            <div class="down-tip">
                <div
                    v-html="
                        $t('Download_prompt_text2', {
                            text: store.curSymbol[store.wallet?.currency] + 777,
                        })
                    "
                ></div>
                {{
                    $t('Download_prompt_text3', {
                        text: $t(`${store.wallet?.currency || store.defaultCurrency.currency}_d_text_num`),
                    })
                }}
            </div>
            <div class="down-btn" @click="download">{{ $t('Download') }}</div>
        </div>
    </div>
    <div ref="footDom" class="footer" :class="{ isWhite }">
        <div
            :class="['l-button', { active: currentTab === index }]"
            v-for="(item, index) in computedTabMenu"
            :key="item.title"
            @click="tab(item, index)"
        >
            <div class="footer-tab">
                <div :class="['footer-icon-bg']">
                    <img v-if="item.type !== 'svg'" :class="['footer-icon']" :src="getImg(item, currentTab === index)" />
                    <!-- <svg v-if="item.type === 'svg'" :class="['footer-icon']">
                        <use :href="item.icon"></use>
                    </svg> -->
                    <svg
                        v-if="item.type === 'svg' && item.icon === '#icon-svg-home-event'"
                        :class="['footer-icon']"
                        width="45"
                        height="38"
                        viewBox="0 0 45 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-v-dc42c6c2=""
                    >
                        <g clip-path="url(#clip0_50_3)" data-v-dc42c6c2="">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M37.4641 30.932L36.7451 27.34L40.3351 26.622L41.0521 30.213L37.4641 30.932ZM33.3721 5.33L34.0591 1.126L38.2481 1.801L37.5741 6.005L33.3721 5.33ZM21.9261 9.889L23.1561 4.169L28.8721 5.399L27.6431 11.119L21.9261 9.889ZM15.6971 0.759L19.4911 0L20.2501 3.796L16.4561 4.554L15.6971 0.759ZM1.51508 37.979C1.23008 38.048 0.931081 37.945 0.750081 37.714C0.571081 37.486 0.539081 37.175 0.669081 36.916L11.3451 13.363L26.4801 32.381L1.51508 37.979Z"
                                fill="#B3BEC1"
                                data-v-dc42c6c2=""
                            ></path>
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M14.496 7.09701C13.771 6.18501 12.439 6.03101 11.528 6.76401C10.609 7.49001 10.462 8.82201 11.194 9.73401L29.609 32.888C30.336 33.8 31.667 33.955 32.578 33.222C33.49 32.496 33.637 31.157 32.912 30.252L14.496 7.09701Z"
                                fill="#24EE88"
                                data-v-dc42c6c2=""
                            ></path>
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M35.397 7.44598L38.182 13.091L44.409 13.996L39.903 18.391L40.967 24.596L35.397 21.667L29.827 24.596L30.891 18.391L26.385 13.996L32.612 13.091L35.397 7.44598Z"
                                fill="#24EE88"
                                data-v-dc42c6c2=""
                            ></path>
                        </g>
                        <defs data-v-dc42c6c2="">
                            <clipPath id="clip0_50_3" data-v-dc42c6c2="">
                                <rect width="45" height="38" fill="white" data-v-dc42c6c2=""></rect>
                            </clipPath>
                        </defs>
                    </svg>

                    <svg
                        v-if="item.type === 'svg' && item.icon === '#icon-svg-home-jackpot'"
                        :class="['footer-icon']"
                        width="44"
                        height="38"
                        viewBox="0 0 44 38"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        data-v-dc42c6c2=""
                    >
                        <g clip-path="url(#clip0_52_12)" data-v-dc42c6c2="">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M36.0459 2.49102V4.16202C40.6259 4.85802 43.9849 8.47702 43.9849 12.931C43.9849 17.525 40.1679 21.283 35.1299 21.7C34.3659 23.371 33.2979 24.902 31.9239 26.155C29.7859 28.104 26.8849 29.356 23.6789 29.635V34.646H32.5339C33.4499 34.646 34.3659 35.342 34.3659 36.316C34.3659 37.29 33.6029 37.986 32.5339 37.986H11.4649C10.5489 37.986 9.63292 37.29 9.63292 36.316C9.63292 35.898 9.78492 35.481 10.0909 35.202C10.3959 34.924 10.8539 34.785 11.3119 34.785H20.1669V29.774C14.9759 29.078 10.5489 25.876 8.86992 21.7C3.98392 21.283 0.013916 17.525 0.013916 12.931C0.013916 8.61602 3.37292 4.99702 7.95292 4.16202V2.49102C7.95292 1.10002 9.17492 -0.0139771 10.8539 -0.0139771H33.2979C34.8239 -0.0139771 36.0459 1.10002 36.0459 2.49102ZM7.95292 7.50202C5.35792 8.19802 3.52592 10.287 3.52592 12.931C3.52592 15.437 5.35792 17.664 7.95292 18.36V7.50202ZM21.0999 26.572C27.8019 26.572 32.5339 22.396 32.5339 17.385V3.18702H11.4649V17.385C11.4649 22.396 16.1979 26.572 21.0999 26.572ZM36.0459 17.385V18.36C38.6409 17.664 40.4739 15.437 40.4739 12.931C40.4739 10.426 38.6409 8.19802 36.0459 7.50202V17.385Z"
                                fill="#B3BEC1"
                                data-v-dc42c6c2=""
                            ></path>
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M20.7241 7.57102L19.3141 10.336C19.1131 10.731 18.7101 10.928 18.3071 10.928L15.0851 11.323C14.0781 11.52 13.6751 12.705 14.2791 13.298L16.6961 15.47C16.8981 15.667 17.0981 16.063 17.0981 16.457L16.4951 19.617C16.2931 20.605 17.5021 21.394 18.5091 20.802L21.3281 19.42C21.7311 19.222 22.1341 19.222 22.5361 19.42L25.3561 20.802C26.3631 21.197 27.3701 20.605 27.3701 19.617L26.7661 16.457C26.7661 16.063 26.7661 15.667 27.1691 15.47L29.5851 13.298C30.3911 12.705 29.9881 11.52 28.7801 11.323L25.5571 10.928C25.1551 10.928 24.7521 10.533 24.5511 10.336L23.1401 7.57102C22.5361 6.78102 21.1271 6.78102 20.7241 7.57102Z"
                                fill="#24EE88"
                                data-v-dc42c6c2=""
                            ></path>
                        </g>
                        <defs data-v-dc42c6c2="">
                            <clipPath id="clip0_52_12" data-v-dc42c6c2="">
                                <rect width="44" height="38" fill="white" data-v-dc42c6c2=""></rect>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="footer-name" v-html="$t(item.title)"></div>
            </div>
        </div>
    </div>
    <!-- </div> -->
    <IosInstruction v-if="showDownload" v-model="showDownload" />
</template>
<script setup lang="ts" name="BaseFooter">
import { useI18n } from 'vue-i18n'
import { useBaseStore } from '@/stores'
import { useJackpotStore } from '@/stores/jackpotStore'
import { storeToRefs } from 'pinia'
import { getDeviceInfo, getUrlParams, getVipBadge } from '@/utils'
import { Log } from '@/api/log'
import { useRouter, useRoute } from 'vue-router'
import { openUrl } from '@/utils/toolsValidate'

const path = '../assets/img/footer-bar/'
const file = import.meta.glob('../assets/img/footer-bar/*', { eager: true })

const i18n = useI18n()
const store = useBaseStore()
const jackpotStore = useJackpotStore()
const { showJackpot } = storeToRefs(jackpotStore)
const showDownload = ref(false)

const props = defineProps({
    initTab: {
        type: Number,
        default: () => 0,
    },
    isWhite: {
        type: Boolean,
        default: () => false,
    },
})
const router = useRouter()
const route = useRoute()
const isRefresh = reactive<{
    [key: string]: boolean
    isRefresh1: boolean
    isRefresh2: boolean
}>({
    isRefresh1: false,
    isRefresh2: false,
})

const IosInstruction = defineAsyncComponent({
    // 加载函数
    loader: () => import('@/views/iosInstruction/index.vue'),
    delay: 2000,
})
// 当前显示的tab记录
const currentTab = ref(props.initTab)
const footDom = ref(null)
// tab数据
const jackpotMenuItem = {
    title: 'Jackpot',
    path: '/jackpot',
    icon: '#icon-svg-home-jackpot',
    type: 'svg',
}

const reelsMenuItem = {
    title: 'Home_Reels',
    path: '/video',
    icon: 'video',
}

const baseTabMenu = [
    {
        title: 'Home_page',
        path: '/',
        icon: 'home',
        isFresh: true,
    },
    // 第二项会根据 showJackpot 动态变化
    jackpotMenuItem,
    {
        title: 'Home_earn_money',
        path: '/earnCash',
        icon: 'earncash',
    },
    {
        title: 'Home_Wallets',
        path: '/wallets',
        icon: 'wallets_active',
    },
    {
        title: 'Home_events',
        path: '/events',
        icon: '#icon-svg-home-event',
        type: 'svg',
    },
]

// 计算属性：根据showJackpot值动态生成菜单
const computedTabMenu = computed(() => {
    const menu = [...baseTabMenu]
    // 如果showJackpot为false，则显示Reels菜单项
    // if (!showJackpot.value) {
    //     menu[1] = reelsMenuItem
    // }
    return menu
})

// 跳转tab
const tab = (item, index) => {
    Log({
        event: `tab_${i18n.t(item.title)}`,
    })
    // 如果有刷新功能，并且是点击的当前tab
    if (item.isFresh && currentTab.value === index) {
        refresh(index)
    } else {
        if (item.path === '/earnCash') {
            Log({
                event: 'tab_earn',
            })
        }
        router.push(item.path)
    }
}

const download = () => {
    if (getDeviceInfo().os === 'iOS') {
        showDownload.value = true
    } else {
        const id = getUrlParams('userId') || route.query.userId
        const partner = getUrlParams('partner') || route.query.partner || 66666666
        // const webid = store.webid || getUrlParams('webId') || route.query.webId || localStorage.getItem('webId')
        const okspinid = getUrlParams('pixel_click_id') || route.query.pixel_click_id || localStorage.getItem('pixel_click_id')
        const okspinext = getUrlParams('_oks_ext') || route.query._oks_ext || localStorage.getItem('_oks_ext')
        openUrl(
            `https://betfugu.com/app_ph.html?partner=${partner}${id ? '&userId=' + id : ''}${okspinid ? '&pixel_click_id=' + okspinid : ''}${
                okspinext ? '&_oks_ext=' + okspinext : ''
            }`
        )
    }
}

// 刷新页面
const refresh = (index) => {
    isRefresh['isRefresh' + index] = !isRefresh['isRefresh' + index]
    setTimeout(() => {
        isRefresh['isRefresh' + index] = !isRefresh['isRefresh' + index]
    }, 2000)
}
const getImg = (item, active = false) => {
    const imgPath = path + `${active ? item.icon + '_active' : item.icon}.png`
    const imgModule = file[imgPath] as any
    return imgModule?.default || ''
}
const getFootReact = () => {
    return footDom.value.getBoundingClientRect()
}
defineExpose({
    getFootReact,
})
</script>
<style scoped lang="scss">
.footer {
    font-size: 25px;
    position: fixed;
    left: 0;
    width: 100%;
    height: var(--footer-height);
    // border-top: 2px solid #3d3b38;
    z-index: 100;
    //不用bottom：0是因为，在进行页面切换的时候，vue的transition
    // 会使footer的bottom：0失效，不能准确定位
    // top: calc(var(--vh, 1vh) * 100 - var(--footer-height));
    // background: var(--footer-color);
    bottom: 0px;
    display: flex;
    background-color: rgb(50, 55, 56);
    border-radius: 20px 20px 0px 0px;
    // border: solid 2px #303446;

    &.isWhite {
        background: white !important;
        color: #000 !important;
    }

    .l-button {
        flex: 1;
        padding-top: 20px;
        position: relative;
        .footer-tab {
            @apply flex flex-col justify-center items-center;
            position: relative;
        }
        .footer-icon-bg {
            display: flex;
            align-items: center;
            width: 50px;
            height: 45px;
            .footer-icon {
                position: relative;
                transform: translateX(-50%);
                left: 50%;
                width: auto;
                height: 100%;
            }
            // &.active {
            //     margin-top: -50px;
            //     width: 113px;
            //     height: 102px;
            // }
        }

        .footer-name {
            text-align: center;
            height: 30px;
            width: 100%;
            font-size: 20px;
            margin-top: 11px;
            font-weight: 1000;
            color: rgb(179, 190, 193);
        }
        &:nth-child(3) {
            .footer-icon-bg {
                margin-top: -50px;
                width: 113px;
                height: 102px;
            }
            .footer-name {
                margin-top: 5px;
                font-size: 26px;
                :deep(span) {
                    color: #71ea92;
                }
            }
        }
    }
}

.footer-down-wrap {
    position: fixed;
    display: flex;
    bottom: var(--footer-height);
    width: 100%;
    height: 140px;
    padding: 0 15px;
    z-index: 100;

    .down-content {
        @apply flex;
        width: 100%;
        height: 94%;
        align-items: center;
        background-image: url('@/assets/img/home/download_bg.png');
        background-size: cover;
        border-radius: 20px 20px 20px 20px;
        // border: solid 2px #303446;
    }
    .down-icon {
        width: 71px;
        height: 67px;
    }
    .down-tip {
        flex: 1;
        margin: auto;
        font-size: 24px;
        color: #fff;
        line-height: 36px;
        text-align: left;
        font-weight: bold;
        margin-left: 270px;
        :deep(span) {
            color: yellow;
            font-size: 32px;
            font-weight: 900;
        }
    }
    .down-btn {
        width: 145px;
        height: 55px;
        margin-top: 4px;
        margin-right: 25px;
        line-height: 55px;
        font-size: 34px;
        // background-image: linear-gradient(0deg, #0e8e66 0%, #10c57f 100%), linear-gradient(#887afb, #887afb);
        background-image: linear-gradient(90deg, #fffc7f 0%, #dfff6d 100%), linear-gradient(#8b0500, #8b0500);
        box-shadow: 0 0 0.16rem rgba(35, 238, 136, 0.3), inset 0 -4px #dfff6d;
        font-size: 24px;
        text-align: center;
        border-radius: 10px;
        font-weight: bold;
        color: #000;
    }
    .down-close {
        position: absolute;
        width: 40px;
        height: 40px;
        left: 18px;
        top: 5px;

        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
